import React from 'react';
import { Box, Chip, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';

const EmailSendFilters = ({
  programName,
  status,
  bac,
  search,
  startDate,
  endDate,
  programOptions,
  statusOptions,
  isTruncated,
  onProgramChange,
  onStatusChange,
  onBacChange,
  onSearchChange,
  onStartDateChange,
  onEndDateChange,
  onResetPage,
}) => {
  const handleChange = (setter) => (event) => {
    setter(event.target.value);
    if (onResetPage) onResetPage();
  };

  return (
    <Stack spacing={2}>
      <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2}>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Program</InputLabel>
          <Select label="Program" value={programName} onChange={handleChange(onProgramChange)}>
            {programOptions.map((program) => (
              <MenuItem key={program} value={program}>
                {program}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Status</InputLabel>
          <Select label="Status" value={status} onChange={handleChange(onStatusChange)}>
            <MenuItem value="">All statuses</MenuItem>
            {statusOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField size="small" label="BAC" value={bac} onChange={handleChange(onBacChange)} />
        <TextField
          size="small"
          label="Search"
          value={search}
          onChange={handleChange(onSearchChange)}
          sx={{ flex: 1 }}
        />
      </Stack>

      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center">
        <TextField
          size="small"
          type="date"
          label="Start"
          value={startDate}
          onChange={handleChange(onStartDateChange)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          size="small"
          type="date"
          label="End"
          value={endDate}
          onChange={handleChange(onEndDateChange)}
          InputLabelProps={{ shrink: true }}
        />
        <Box>{isTruncated && <Chip label="Results truncated" color="warning" variant="outlined" />}</Box>
      </Stack>
    </Stack>
  );
};

export default EmailSendFilters;
